module.exports = __webpack_public_path__ + "img/pic4.2a5b53f1.png";